import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { EggNumber } from './EggNumber';
import AnimationWithSound from '../AnimationWithSound';
import eggBrokenSound from '../sounds/play-egg-broken.mp3';
import { useSelector } from 'react-redux';

export const BOSS_EGG = {
  NOT_DISPLAYED: 0,
  NORMAL: 1,
  BROKEN: 2,
};

const BossEgg = ({ amount, state }) => {
  const { images } = useImagesContext();
  const config = useSelector((state) => state.config);
  const [ownState, setOwnState] = React.useState([state]);

  React.useEffect(() => {
    if (state === BOSS_EGG.BROKEN) {
      setOwnState((v) => [...v, state]);
      setTimeout(() => {
        setOwnState([state]);
      }, 500);
    } else {
      setOwnState([state]);
    }
  }, [state]);

  return (
    <>
      {ownState.includes(BOSS_EGG.NORMAL) && (
        <Block $background={images['play-egg-boss.png']}>
          <EggNumber
            number={amount}
            top="55px"
            fontHeight="84px"
            filePrefix="play-egg-boss-"
          />
        </Block>
      )}
      {ownState.includes(BOSS_EGG.BROKEN) && (
        <AnimationWithSound
          imageUrl={images['play-boss-egg-broken.png']}
          imageTop={830}
          imageRight={5}
          imageWidth={240}
          imageHeight={245}
          soundFile={eggBrokenSound}
          playSound={!config.isMutedSound}
        />
      )}
    </>
  );
};

const Block = styled.div`
  position: absolute;
  top: 850px;
  right: 20px;
  width: 159px;
  height: 177px;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-repeat: no-repeat;
`;

const BossEggBroken = styled.img`
  position: absolute;
  top: 830px;
  right: 5px;
  width: 240px;
  height: 245px;
`;

export default BossEgg;
